import React, { Fragment } from "react";

import "@/styles/pages/contat-us/contact-directly.scss";
import CardComponent from "@/components/card";
import IconSupport from "@/components/icons/IconSupport";
import IconCall from "@/components/icons/IconCall";
import IconPuzzle from "@/components/icons/IconPuzzle";

const ContactDirectly = () => {
  return (
    <Fragment>
      <div className="contact-directly-wrapper">
        <CardComponent>
          <div className="heading body-b3">
            <span>Or, Directly reach us anytime!</span>
          </div>

          <div className="contact-info">
            <div className="contact-item body-b4">
              <IconSupport />
              <span className="item-label">
                Support: <a href="mailto:support@inforens.com">support@inforens.com</a>
              </span>
            </div>
            <div className="contact-item body-b4">
              <IconCall />
              <span className="item-label">
                Mobile No: <a href="tel:+447587039853">+44 7587 039853</a>
              </span>
            </div>
            <div className="contact-item body-b4">
              <IconPuzzle />
              <span className="item-label">
                Product Enquiry: <a href="mailto:contact@inforens.com">contact@inforens.com</a>
              </span>
            </div>
          </div>
        </CardComponent>
      </div>
    </Fragment>
  );
};

export default ContactDirectly;
